module.exports = __webpack_public_path__ + "static/media/user.c813261c.png";